<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card v-if="!isWscRetrieved">
                    <div slot="header">
                        <strong>{{title}}</strong>
                    </div>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group name="invoice" label="Credit Note No" label-for="elementsPrependAppend" description="">
                                <b-input-group>
                                    <wscLookup style="min-width:300px" v-bind:url="apiWscUrl" v-on:selected="setWsc($event)" :lookupId="wsc.credit_note_number" :basic="1" ref="wscLookupInput"/>&nbsp;&nbsp;&nbsp;
                                    <b-button variant="primary" @click="retrieveSalesDoc" :disabled="wsc.credit_note_number == ''">Retrieve Cancellation Document</b-button>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                      </b-row>
                </b-card>
                <b-card v-if="isWscRetrieved">
                    <div slot="header">
                        <strong>{{title}}</strong>
                    </div>
                    <b-row>
                        <b-col>
                            <b-row>
                                <b-col sm="12">
                                    <b-form-group>
                                        <label for="receiving_date" >Receiving Date</label>
                                            <b-form-input type="date" v-model="wsc.wsc_date" :disabled="lockEntry"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>

                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group>
                                <label for="remarks">Remarks</label>
                                    <textarea class="form-control" rows="5" id="remarks" v-model="wsc.remarks" :disabled="lockEntry"></textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3">
                            <label for="status">Sales Cancellation Approval Status</label>
                                <b-form-input type="text" v-model="wsc.cancellation_status_name" disabled/>
                        </b-col> 
                        <b-col sm="3">
                            <label for="status">Receiving Status</label>
                                <b-form-input type="text" v-model="wsc.receiving_status" disabled/>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="location_id">Receiving Location (Warehouse)</label>
                                    <b-form-input type="text" v-model="wsc.stock_location_name" disabled></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <label>Transaction Type</label>
                                <b-form-input type="text" v-model="wsc.cancellation_reason_name" disabled/>
                        </b-col> 
                    </b-row>
                    <b-row>
                        <b-col sm="3">
                            <label for="credit_note_number">Credit Note No</label>
                                <b-form-input type="text" v-model="wsc.credit_note_number" disabled/>
                        </b-col>
                        <b-col sm="3">
                            <label for="transaction_date">Cancellation Date</label>
                                <b-form-input type="date" v-model="wsc.transaction_date" disabled/>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="customer_id">IBO/Stockist ID</label>
                                    <b-form-input type="text" v-model="wsc.old_member_id" disabled/>
                            </b-form-group>
                        </b-col> 
                        <b-col sm="3">
                            <label>IBO/Stockist Name</label>
                                <b-form-input type="text" v-model="wsc.member_name" disabled/>
                        </b-col> 
                    </b-row>
                    <b-row>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="cancellation_doc_num">Buy Back Amount ({{wsc.currency_code}})</label>
                                    <b-form-input type="text" v-model="wsc.amount_buy_back" disabled/>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label>Cancellation Amount ({{wsc.currency_code}})</label>
                                    <b-form-input type="text" v-model="wsc.amount_cancellation" disabled/>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label>Confirmed Return Amount ({{wsc.currency_code}})</label>
                                    <b-form-input type="text" :value="confirm_return_amount" disabled/>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label>Tax Invoice Number</label>
                                    <b-form-input type="text" v-model="wsc.tax_invoice_number" disabled/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="isWscRetrieved">
            <b-col sm="12">
                <b-card>
                    <div slot ="header">
                        <strong>Sales Cancellation Items</strong>
                    </div>
                    <div class="table-responsive">
                        <table class='table table-striped table-bordered'>
                            <thead>
                                <th style="min-width:300px">Product Name</th>
                                <th width="250px">SKU</th>
                                <th width="200px">Cancellation Qty</th>
                                <th width="250px">Cancellation Amount ({{wsc.currency_code}})</th>
                                <th width="200px">Returned Qty</th>
                                <th width="200px">Receiving Qty</th>
                                <th width="250px">Receiving Amount ({{wsc.currency_code}})</th>
                            </thead>
                            <tbody>
                                <tr v-for="row, index in wsc.items" >
                                    <td>{{row.product_name}}</td>
                                    <td >{{row.product_id}}</td>
                                    <td>{{row.quantity}}</td>
                                    <td>{{row.cancellation_amount_friendly}}</td>
                                    <td>{{row.qty_returned}}</td>
                                    <td><input type="number" min="0" name="qty_returned" v-model="row.qty_allocated" class="form-control" :disabled="row.qty_returned == row.quantity" @change="validateQtyAllocated(row)"/></td>
                                    <td>{{((((row.cancellation_amount*1)/(row.quantity*1)))*(row.qty_allocated*1)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                </tr>
                            </tbody>
                    </table>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="isWscRetrieved">
            <b-col sm="12">
                <b-row style="padding: 0px 0px 20px 18px;">
                    <b-button type="submit" size="lg" variant="primary" @click="save" v-if="!isVisible" >Save WSC</b-button>&nbsp;&nbsp; 
                    <b-button type="submit" size="lg" variant="success" @click="print" v-if="isVisible">Print</b-button>&nbsp;&nbsp;                                                      
                    <b-button type="submit" size="lg" variant="danger" @click="closeWSC" >Back</b-button>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-modal ref="myModalRef" hide-header-close hide-footer title="Sales Cancellation" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
                <div class="d-block text-center">
                        <p>Sales Cancellation <strong style="color:green"> {{wscDocNo}}</strong> is saved.<br/><br/></p>
                </div>
                <b-btn class="float-right" variant="outline-danger" @click="hideModal">Ok</b-btn>
            </b-modal>
            <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
                <div class="d-block text-center">
                        <p style="color:red">{{errorMessage}}</p>
                </div>
                <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
            </b-modal>     
        </b-row>
    </div>
</template>
<script>
import axios from 'axios'
import warehouseLookup from '@/components/Autocomplete.vue'
import productLookup from '@/components/Autocomplete.vue'
import wscLookup from '@/components/Autocomplete.vue'
import {authHeader, apiWarehouseLookup, apiLocationProductUrl,apiWscLookUp,apiWscSave,apiCountryLookup} from '@/functions/common.vue'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    },
};
export default
{
    components:{warehouseLookup,wscLookup},
    data: () => {
        return {
            title:'New Sales Cancellation',
            apiWarehouseUrl:apiWarehouseLookup,
            apiWscUrl:apiWscLookUp,
            isVisible:false,
            wsc_ref: '',
            list:[],
            font:'ukai',
            item:{},
            lockEntry:false,
            isWscRetrieved:false,
            wscDocNo:'12345',
            errorMessage:'',
            wsc :{},
            country_name:'',
        }
    },
    created()
    {
        if (localStorage.getItem("wsc_new.credit_note_number") != '')
        {
                this.isWscRetrieved = true
                var wscNum = localStorage.getItem("wsc_new.credit_note_number")
                var url = this.apiWscUrl
                
                axios.get(url, {params: {q: wscNum, get:1}},authHeader())
                .then(response => 
                {
                    this.list = response.data.data.list
                    if (this.list.length > 0)
                    {
                        this.item = this.list[0]

                        if (this.item !== null)
                        {
                            this.isWscRetrieved = true
                            
                            this.wsc=this.item.wsc[0]
                            if(this.wsc.old_member_id == null)
                            {
                                this.wsc.old_member_id = this.item.old_member_id
                            }
                            this.wsc.receiving_status = this.item.wsc.receiving_status
                            if(this.wsc.country_code != null)
                            {
                                axios.get(apiCountryLookup, {params: {q: this.wsc.country_code}})
                                    .then(response => 
                                    {

                                        if(this.wsc.country_code == 'TH')
                                        {
                                            this.font = 'Garuda'
                                        }
                                        else if(this.wsc.country_code == 'KH')
                                        {
                                            this.font = 'Hanumanb'
                                        }
         
                                        if (response.data != null)
                                        {
                                            this.list = response.data.data.list
                                            this.item = this.list[0]
                                            this.country_name = this.item.country_name
                                            this.country_name = this.country_name.toUpperCase()
                                        }
                                    })
                            }
                            let curDate = new Date()
                            curDate = curDate.toISOString().substr(0,10)
                            this.wsc.wsc_date = curDate  
                        }
                        var totalQty = 0
                        var totalQtyReturned = 0
                        for(let key in this.wsc.items)
                        {
                            var wsc_item = this.wsc.items[key]
                            wsc_item.quantity = wsc_item.quantity * 1
                            wsc_item.qty_returned = wsc_item.qty_returned*1
                            this.wsc.items[key].cancellation_amount_friendly = (wsc_item.cancellation_amount*1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            totalQty = totalQty + wsc_item.quantity
                            totalQtyReturned = totalQtyReturned + wsc_item.qty_returned
                        }
                        if(totalQty == totalQtyReturned)
                        {
                            this.isVisible = true
                        }
                    }
                })
                .catch(error => alert(error))
            }
            else
            {
                this.isWscRetrieved = false
                this.wsc.credit_note_number = ''
            }
    },
    computed:
    {
        confirm_return_amount() {
            var total = 0;
            for(let k in this.wsc.items)
            {
                var item = this.wsc.items[k]
                item.qty_allocated = item.qty_allocated*1
                item.quantity = item.quantity*1
                item.cancellation_amount = item.cancellation_amount *1
                var receiving_amount = (item.cancellation_amount *item.qty_allocated) / item.quantity
                total = total + receiving_amount
            }
            total = total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            return total
        },
    },
    methods:
    {
        print() 
        {
                    var wsc_num = this.wsc.credit_note_number
                    var row = []
                    var date = new Date(this.wsc.transaction_date)
                    var cancellationDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    var wscItems = []
                    var groTotalAmount = 0
                    row = [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'Product Code',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Description',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Cancellation Amount',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Cancellation Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        },
                        {
                            text: 'Returned Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        },
                    ]
                    wscItems.push(row)
                    var items = this.wsc.items
                    for (let key in items) {
                        var data = items[key]
                        var cancellation_amount = (data.cancellation_amount * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var qty = (data.quantity* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var qty_returned = (data.qty_returned* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        if (data.product_name == null) 
                        {
                            data.product_name = ""
                        }
                        row = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: data.product_id,
                                style: 'itemText'
                            },
                            {
                                text: data.product_name,
                                style: 'itemText'
                            },
                            {
                                text: cancellation_amount,
                                style: 'itemText'
                            },
                            {
                                text: qty,
                                style: 'itemNumber'
                            },
                            {
                                text: qty_returned,
                                style: 'itemNumber'
                            },
                        ]
                        wscItems.push(row)
                    }
                    var ddHeader = {
                        columns: [
                            [{
                                    text: 'ELKEN ' + this.country_name + ' SALES CANCELLATION',
                                    style: 'invoiceTitle',
                                    width: '*'
                                },
                                {
                                    stack: [{
                                            columns: [
                                                {
                                                    text: 'Cancellation Doc #',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: wsc_num,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Sales Doc #',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wsc.invoice_number,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Tax Invoice #',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wsc.tax_invoice_number,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [

                                                {
                                                    text: 'Transaction Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: cancellationDate,
                                                    style: 'invoiceSubValue',
                                                    width: 100

                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Transaction Location',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wsc.stock_location_name,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]

                                        },
                                        {text :' '},
                                        {
                                            columns: [
                                                {
                                                    text: 'Approval Status',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wsc.cancellation_status_name,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]

                                        },
                                        {text :' '},
                                        {
                                            columns: [
                                                {
                                                    text: 'Receiving Status',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wsc.receiving_status,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]
                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Transaction Type',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wsc.cancellation_reason_name,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Member',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wsc.old_member_id + ' - ' + this.wsc.member_name,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: 
                                            [
                                                {
                                                    text: 'Buy Back Amount',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: (this.wsc.amount_buy_back*1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                                                    style: 'invoiceSubValue',
                                                }

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Cancellation Amount',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: (this.wsc.amount_cancellation*1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                                                    style: 'invoiceSubValue',
                                                },

                                            ]
                                        },
                                    ]
                                }
                            ],
                        ],
                    }

                    var dd = {
                        header: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 10, 0, 0],
                                columns: [{
                                        text: '',
                                        style: 'documentHeaderLeft'
                                    },
                                    {
                                        text: wsc_num,
                                        style: 'documentHeaderCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentHeaderRight'
                                    }
                                ]
                            }
                        },
                        footer: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 0, 0, 50],
                                columns: [{
                                        text: '',
                                        style: 'documentFooterLeft'
                                    },
                                    {
                                        text: 'Page ' + pageNumber + " of " + pageCount,
                                        style: 'documentFooterCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentFooterRight'
                                    }
                                ]
                            };
                        },
                        content: [
                            ddHeader,
                            // Line breaks
                            '\n\n',
                            {
                                layout: 'lightHorizontalLines',
                                table: {

                                    headerRows: 1,
                                    widths: [25, 'auto', 'auto', 'auto', 'auto','auto'],
                                    body: wscItems

                                }, // table
                            },
                            {
                                columns: [
                                        {
                                            stack: [
                                                { 
                                                    text: 'Received By',
                                                    style:'signaturePlaceholder'
                                                },

                                                { 
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                { 
                                                    text: 'Name  :',
                                                    style:'signatureName'
                                                    
                                                },
                                                { 
                                                    text: 'Date  :',
                                                    style:'signatureJobTitle'
                                                    
                                                }
                                                ],
                                                width: 160
                                        }

                                    ]
                        }, 
                        ],
                        styles: {
                            // Document Header
                            documentHeaderLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentHeaderCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentHeaderRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Document Footer
                            documentFooterLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentFooterCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentFooterRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Invoice Title
                            invoiceTitle: {
                                fontSize: 22,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 15]
                            },
                            // Invoice Details
                            invoiceSubTitle: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            invoiceSubValue: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            // Billing Headers
                            invoiceBillingTitle: {
                                fontSize: 14,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 20, 0, 5],
                            },
                            // Billing Details
                            invoiceBillingDetails: {
                                alignment: 'left'

                            },
                            invoiceBillingAddressTitle: {
                                margin: [0, 7, 0, 3],
                                bold: true
                            },
                            invoiceBillingAddress: {

                            },
                            // Items Header
                            itemsHeader: {

                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true
                            },
                            // Item Title
                            itemTitle: {
                                bold: true,
                            },
                            itemSubTitle: {
                                //italics: true,
                                fontSize: 10
                            },
                            itemText: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                            },
                            itemNumber: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'right',
                            },
                            itemTotal: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },

                            // Items Footer (Subtotal, Total, Tax, etc)
                            itemsFooterSubTitle: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterSubValue: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            itemsFooterTotalTitle: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterTotalValue: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            signaturePlaceholder: {
                                fontSize: 10,
                                margin: [0, 70, 0, 0],
                            },
                            signatureName: {
                                fontSize: 10,
                                margin: [0, 10, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            signatureJobTitle: {
                                fontSize: 10,
                                margin: [0, 20, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            notesTitle: {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 30, 0, 3],
                            },
                            notesText: {
                                fontSize: 10
                            },
                            center: {
                                alignment: 'center',
                            },
                        },
                        defaultStyle: {
                            columnGap: 20,
                            font:this.font
                        }
                    }
                    pdfMake.createPdf(dd).open();
        },
        validateQtyAllocated(row)
        {
            row.qty_allocated = row.qty_allocated*1
            row.quantity = row.quantity*1
            row.qty_returned = row.qty_returned * 1
            var allowQty = row.quantity - row.qty_returned
            if(row.qty_allocated < 0)
            {
                row.qty_allocated = 0
            }
            if(row.qty_allocated > allowQty)
            {
                row.qty_allocated = 0
            }
        },
        setWsc(obj)
        {
        
                if (obj !== null)
                {
                    if(obj.id != '')
                    {
                        this.wsc = obj.wsc[0]
                        if(this.wsc.old_member_id == null)
                        {
                            this.wsc.old_member_id = obj.old_member_id
                        }

                        console.log(obj.wsc.receiving_status)
                        this.wsc.receiving_status = obj.wsc.receiving_status
                        let curDate = new Date()
                        curDate = curDate.toISOString().substr(0,10)
                        this.wsc.wsc_date = curDate
                        var totalQty = 0
                        var totalQtyReturned = 0
                        for(let key in this.wsc.items)
                        {
                            var wsc_item = this.wsc.items[key]
                            wsc_item.quantity = wsc_item.quantity * 1
                            wsc_item.qty_returned = wsc_item.qty_returned*1
                            totalQty = totalQty + wsc_item.quantity
                            totalQtyReturned = totalQtyReturned + wsc_item.qty_returned
                        }
                        if(totalQty == totalQtyReturned)
                        {
                            this.isVisible = true
                        }
                    }     
                } 
                else
                {
                    this.isWscRetrieved = false
                    this.wsc.credit_note_number = null
                }
        },
        retrieveSalesDoc()
        {
            this.isWscRetrieved = true
            
        },
        setWarehouse(obj)
        {
          var id

          if (obj !== null)
          {
            id = obj.id
          } 
          else
          {
            id = null
            //this.countryId =null
          }
          this.wsc.location_id = id
        },
        save()
        {
            axios.post(apiWscSave, this.wsc, authHeader())
                        .then (res => { 
                        var r = res.data
                        if(r.code == 1)
                        {
                            this.wscDocNo = r.data
                            this.$refs.myModalRef.show()
                        }
                        else
                        {
                            this.errorMessage = r.data
                            this.$refs.myErrorModalRef.show()
                        }
                        })
            .catch(error => alert(error))
         
        },
        closeWSC()
        {
            this.$router.push({ name: 'Sales Cancellations (SCS)'})
        },
        close()
        {
            this.$router.push({ name: 'Sales Cancellations (SCS)'})
        },
        hideModal () 
        {
            this.$refs.myModalRef.hide()
            this.$router.push({ name: 'Sales Cancellations (SCS)'})
        },
        hideErrorModal()
        {
            this.$refs.myErrorModalRef.hide()
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/wsc/wsc.vue